import { render, staticRenderFns } from "./PrintCard.vue?vue&type=template&id=ed74354e&scoped=true"
import script from "./PrintCard.vue?vue&type=script&lang=js"
export * from "./PrintCard.vue?vue&type=script&lang=js"
import style0 from "./PrintCard.vue?vue&type=style&index=0&id=ed74354e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed74354e",
  null
  
)

export default component.exports